import { useEffect, useRef, useState, CSSProperties } from 'react'
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import { getRequestOptions } from '../helpers/Fetchwrapper';
import Select from 'react-select';

function QuotationRowActions({ row }: { row: any }) {
    const [open, setOpen] = useState(false)
    const [menuStyle, setMenuStyle] = useState<CSSProperties>({ display: 'none' })
    const containerRef = useRef<HTMLDivElement>(null)
    const buttonRef = useRef<HTMLButtonElement>(null)

    const updateMenuPosition = () => {
        if (!buttonRef.current) {
            return
        }

        const rect = buttonRef.current.getBoundingClientRect()
        setMenuStyle({
            position: 'fixed',
            top: `${rect.bottom + 2}px`,
            left: `${rect.right}px`,
            transform: 'translateX(-100%)',
            minWidth: 'max-content',
            width: 'auto',
            whiteSpace: 'nowrap',
            zIndex: 1050,
            display: 'block',
        })
    }

    useEffect(() => {
        if (!open) {
            setMenuStyle({ display: 'none' })
            return
        }

        updateMenuPosition()

        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setOpen(false)
            }
        }

        const handleReposition = () => setOpen(false)

        document.addEventListener('mousedown', handleClickOutside)
        window.addEventListener('scroll', handleReposition, true)
        window.addEventListener('resize', handleReposition)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            window.removeEventListener('scroll', handleReposition, true)
            window.removeEventListener('resize', handleReposition)
        }
    }, [open])

    const closeMenu = () => setOpen(false)

    return (
        <div ref={containerRef} className="d-flex justify-content-center">
            <button
                ref={buttonRef}
                className="btn btn-light-primary btn-sm dropdown-toggle"
                type="button"
                aria-expanded={open}
                onClick={(e) => {
                    e.stopPropagation()
                    setOpen((prev) => !prev)
                }}
            >
                Action
            </button>
            <div className="dropdown-menu dropdown-menu-end show" style={menuStyle}>
                <a
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.REACT_APP_BACKEND}quotationDownload/${row.idSalesQuotations}`}
                    onClick={closeMenu}
                >
                    <KTSVG
                        path='/media/svg/icons/Devices/Printer.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Download
                </a>
                {row.doublePrint === 'Yes' && (
                    <a
                        className="dropdown-item d-flex align-items-center text-nowrap"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${process.env.REACT_APP_BACKEND}quotationDownload/${row.idSalesQuotations}?withoutBackground=1`}
                        onClick={closeMenu}
                    >
                        <KTSVG
                            path='/media/svg/icons/Devices/Printer.svg'
                            className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                        />
                        Download without Background
                    </a>
                )}
                <Link
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    to={`/sales-quotation/${row.idSalesQuotations}`}
                    onClick={closeMenu}
                >
                    <KTSVG
                        path='/media/svg/icons/Layout/Layout-grid.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Details
                </Link>
                <Link
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    to={`/sales-quotation-create?idSalesQuotations=${row.idSalesQuotations}`}
                    onClick={closeMenu}
                >
                    <KTSVG
                        path='/media/svg/icons/Design/Edit.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Edit
                </Link>
            </div>
        </div>
    )
}

function SalesQuotation() {


    const hasPermission = 1; //parseInt(GetPagePermission("/setup-company-list"));

    const [selectProjectOptions, setSelectProjectOptions] = useState([])
    const [project, setProject] = useState({ label: 'Select Project', value: '' });

    const handleProjectChange = (project: any) => {
        setProject(project);

    }

    const getProjectList = async () => {
        const url = process.env.REACT_APP_API_URL + 'projects';

        const response = await fetch(url, getRequestOptions());

        const data = await response.json();

        data.data.map((element: any) => {
            element.value = element.id_projects;
            element.label = element.project_name;
            return element;
        })

        if (data.data.length === 1) {
            setSelectProjectOptions(data.data)
        } else {
            var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
            let allProjects = data.data.concat(allProjectsOpt);
            setSelectProjectOptions(allProjects);
        }
    }

    useEffect(() => {
        getProjectList();
    }, [])

    useEffect(() => {
        if (selectProjectOptions.length === 1) {
            setProject({ label: selectProjectOptions[0]['label'], value: selectProjectOptions[0]['value'] })
        }
    }, [selectProjectOptions])

    const columns = [
        { value: 'id', title: 'ID', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
        { value: 'leadName', title: 'Lead', style: { textAlign: 'left' } },
        { value: 'quotationDate', title: 'Date', style: { textAlign: 'left' } },
        { value: 'referenceNo', title: 'Reference No', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'center' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return <QuotationRowActions row={row} />
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        leadName: {
            filterType: 'like',
            filterValue: '',
        },
        quotationDate: {
            filterType: 'remarks',
            filterValue: '',
        },
        referenceNo: {
            filterType: 'remarks',
            filterValue: '',
        },
        createdBy: {
            filterType: 'remarks',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'quotation/dt'

    useEffect(() => {
        setAdditionalPostData({ idProjects: project.value })
    }, [project])

    const [additionalPostData, setAdditionalPostData] = useState({ idProjects: '' });

    return (
        <>
            {hasPermission === 1 &&
                <div className='card card-custom'>
                    <div className='card-header'>
                        <div className="card-title">
                            <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                            <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                Sales Quotations
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <div className='d-flex justify-content-end'>
                                <Select
                                    // defaultValue={selectProjectOptions}
                                    onChange={handleProjectChange}
                                    options={selectProjectOptions}
                                    placeholder={project.label}
                                />
                                &nbsp;
                                <Link to={`/sales-quotation-create`} className="btn btn-sm btn-primary"><i className="fa fa-plus"></i>Create New Quotation</Link>
                            </div>
                        </div>
                    </div>

                    <div className='card-body'>
                        <DataTable url={url} columns={columns} filters={filters} additionalPostData={additionalPostData} />
                    </div>
                </div >
            }


            {/* {hasPermission === 0 &&
                <Error />
            }
            {hasPermission === 0 &&
                <div className='card card-custom' style={{ padding: "15px" }} >
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40} ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            } */}

        </>
    )
}

export default SalesQuotation
